import React, { useState, useEffect } from 'react';
import { useParams, Link as RouterLink, useNavigate } from 'react-router-dom';

import getContractById from 'src/contract/use-cases/getContractById';
import ContractForm from 'src/contract/ui/components/ContractForm';

const ContractFormView = () => {
  const { contractId } = useParams();
  const [contractData, setContractData] = useState(null);

  const navigate = useNavigate();

  const fetchForm = async () => {
    const contract = await getContractById(contractId);
    setContractData(contract);
  };

  useEffect(() => {
    fetchForm();
  }, []);

  const handleContractFormCancel = () => {
    navigate('/app/contracts');
  };

  const handleContractFormSuccess = () => {
    navigate('/app/contracts');
  };

  return (
    <>
      {contractData ? (
        <ContractForm
          customerId={contractData.headquarterCustomerId}
          contractId={contractId}
          cancel={handleContractFormCancel}
          success={handleContractFormSuccess}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default ContractFormView;
